import { useState } from 'react';

export const useShopPagination = (initialPages = { home: 1, jobs: 1, sales: 1, special: 1 }) => {
  const [currentPages, setCurrentPages] = useState(initialPages);

  const handlePageChange = (tabKey, newPage) => {
    setCurrentPages((prev) => ({ ...prev, [tabKey]: newPage }));
  };

  return {
    currentPages,
    handlePageChange
  };
};
